// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2arbo","title":"AfterBackImages_title__229e5","images":"AfterBackImages_images__2zpos"};